import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import { store } from './store'
import firebase from 'firebase'
import vueScrollTo from 'vue-scrollto'

Vue.use(Vuetify);

firebase.initializeApp({
    apiKey: "AIzaSyBO_ZbH64QCfCR0roNrWb7ItAbTS_mc9Mc",
    authDomain: "textchecker-13237.firebaseapp.com",
    databaseURL: "https://textchecker-13237.firebaseio.com",
    projectId: "textchecker-13237",
    storageBucket: "textchecker-13237.appspot.com",
    messagingSenderId: "493506407459"
});


Vue.config.productionTip = false

/* eslint-disable no-new */
const unsubscribe = firebase.auth()
.onAuthStateChanged((firebaseUser) => {
  new Vue({
    el: '#app',
    router,
    store,
    vueScrollTo,
    render: h => h(App),
    created () {
      firebase.auth().onAuthStateChanged((firebaseUser) => {
        if (firebaseUser) {
          store.dispatch('autoSignIn', firebaseUser);
        }
      });
    }
  })
  unsubscribe();
});



// WEBPACK FOOTER //
// ./src/main.js